/**
 * Menu entries: views and groups outside views (ADR 0005). Blocks and groups inside a view
 * never appear in the menu. Same rule as `isMenuNode` in apps/apolloserver/src/access.
 */
export function isMenuNode(node) {
  return node.kind === 'view' || (node.kind === 'group' && node.viewId === null);
}
